import { Select } from 'antd';
import { RefObject, useCallback, useMemo } from 'react';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import { filterOption } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DescriptionTypeFilterInput.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'business-log-filter-pane'
);
addTranslations(translations);

interface DescriptionTypeFilterInputProps {
  formRef: RefObject<FormInstance | null>;
  onChange?: (value?: string) => void;
  value?: string;
}

export const DescriptionTypeFilterInput = (
  props: DescriptionTypeFilterInputProps
) => {
  const { onChange, formRef, value } = props;
  const { t } = useTranslation();
  const descriptionTypeOptions = useMemo(
    () => [
      {
        value: 'ALL',
        label: t('field.descriptionType.ALL'),
      },
      {
        value: 'INPUT_GROUP',
        label: t('field.descriptionType.INPUT_GROUP'),
      },
      {
        value: 'INPUT',
        label: t('field.descriptionType.INPUT'),
      },
      {
        value: 'OUTPUT_GROUP',
        label: t('field.descriptionType.OUTPUT_GROUP'),
      },
      {
        value: 'OUTPUT',
        label: t('field.descriptionType.OUTPUT'),
      },
      {
        value: 'INTERMEDIATE',
        label: t('field.descriptionType.INTERMEDIATE'),
      },
      {
        value: 'REPORT',
        label: t('field.descriptionType.REPORT'),
      },
    ],
    [t]
  );

  const handleChange = useCallback(
    (value: string | undefined) => {
      onChange?.(value);
      formRef.current?.setFieldsValue({
        description: '',
      });
    },
    [formRef, onChange]
  );

  return (
    <Select
      id="descriptionType-filter"
      defaultValue={value ?? 'ALL'}
      filterOption={filterOption}
      onChange={handleChange}
      options={descriptionTypeOptions}
      placeholder={t('field.descriptionType.placeholder')}
    />
  );
};
